module.exports = __webpack_public_path__ + "static/img/login-qq@2x.0078eb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login-qq@2x.png
// module id = Cvcy
// module chunks = 1